export const H1 = ({ children }: { children: React.ReactNode }) => {
  return (
    <h1 className='text-4xl sm:text-5xl leading-11 sm:leading-[60px] font-semibold'>{children}</h1>
  );
};

export const H2 = ({
  whiteText = false,
  children,
}: {
  whiteText?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <h2
      className={`text-3xl sm:text-4xl leading-[38px] sm:leading-10 font-semibold text-gray-800 ${whiteText ? 'text-white' : ''}`}
    >
      {children}
    </h2>
  );
};

export const H3 = ({ children }: { children: React.ReactNode }) => {
  return <h3 className='text-3xl leading-[38px] sm:leading-10 font-medium'>{children}</h3>;
};

export const Description = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='mt-4 sm:mt-5 mb-8 sm:mb-12 sm:max-w-[768px] text-lg leading-7 text-gray-500'>
      {children}
    </div>
  );
};
